import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { authService } from '@/services/api'

export const useAuthStore = defineStore('auth', () => {
  // 安全解析JSON，处理损坏的localStorage数据
  const safeJsonParse = (key, defaultValue) => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch (e) {
      console.warn(`⚠️ [AuthStore] localStorage数据损坏，已清除: ${key}`)
      localStorage.removeItem(key)
      return defaultValue
    }
  }

  const token = ref(localStorage.getItem('token') || '')
  const user = ref(safeJsonParse('user', null))

  const isAuthenticated = computed(() => !!token.value)

  const login = async (username, password) => {
    console.log('🔐 [AuthStore] 开始登录:', username)
    try {
      const response = await authService.login(username, password)
      console.log('✅ [AuthStore] 登录响应:', response)
      // 后端返回结构: { code: 200, data: { token, user } }
      const { token: newToken, user: newUser } = response.data || {}
      console.log('✅ [AuthStore] 解析token:', newToken?.substring(0, 20) + '...')
      token.value = newToken || ''
      user.value = newUser || null
      if (newToken) {
        localStorage.setItem('token', newToken)
      }
      if (newUser) {
        localStorage.setItem('user', JSON.stringify(newUser))
      }
      console.log('✅ [AuthStore] 已保存token和用户信息到localStorage')
      return { success: true }
    } catch (error) {
      console.error('❌ [AuthStore] 登录失败:', error)
      // 返回错误信息，包含后端返回的详细错误
      return {
        success: false,
        error: error.response?.data || {
          message: error.message || '登录失败',
          code: error.response?.status || 500
        }
      }
    }
  }

  const logout = () => {
    console.log('👋 [AuthStore] 执行logout, 清除认证信息')
    token.value = ''
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    console.log('✅ [AuthStore] 已清除认证信息')
  }

  const getToken = () => {
    return token.value
  }

  const getUser = () => {
    return user.value
  }

  return {
    token,
    user,
    isAuthenticated,
    login,
    logout,
    getToken,
    getUser
  }
})
